"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonProps = exports.Button = void 0;
var _style = _interopRequireDefault(require("styled-jsx/style"));
var _react = _interopRequireWildcard(require("react"));
var _kuiTypes = require("../styles/kuiTypes");
var _Icon = require("../Icon");
var _buttonModule = _interopRequireDefault(require("./button.module.scss"));
var _registerWidgetForDnD = require("../styles/registerWidgetForDnD");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var buttonProps = {
  variant: ["primary", "secondary", "tertiary"],
  color: _kuiTypes.colors,
  size: ["m", "s", "l"],
  disabled: false,
  loading: false,
  leftIcon: _Icon.ICON_NAMES,
  rightIcon: _Icon.ICON_NAMES,
  label: "",
  children: ""
};
exports.buttonProps = buttonProps;
var Button = function Button(props) {
  var _props$variant = props.variant,
    variant = _props$variant === void 0 ? "primary" : _props$variant,
    _props$color = props.color,
    color = _props$color === void 0 ? "primary" : _props$color,
    leftIcon = props.leftIcon,
    rightIcon = props.rightIcon,
    _props$size = props.size,
    size = _props$size === void 0 ? "m" : _props$size,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    onClick = props.onClick,
    children = props.children;
  var _useState = (0, _react.useState)(props.loading),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  (0, _react.useEffect)(function () {
    setLoading(props.loading);
  }, [props.loading]);
  var handleClick = function handleClick(e) {
    if (onClick) {
      var clickResult = onClick(e);
      if (clickResult instanceof Promise) {
        setLoading(true);
        clickResult.finally(function () {
          return setLoading(false);
        });
      }
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("button", {
    disabled: loading || disabled,
    onClick: handleClick,
    className: "jsx-".concat(_buttonModule.default.__hash) + " " + "btn btn-".concat(variant, " btn-color-").concat(color, " btn-").concat(size, " ").concat(loading ? "loading" : "", " ").concat(disabled ? "disabled" : "")
  }, leftIcon && /*#__PURE__*/_react.default.createElement("i", {
    className: "jsx-".concat(_buttonModule.default.__hash) + " " + "fa fa-".concat(leftIcon)
  }), children, rightIcon && /*#__PURE__*/_react.default.createElement("i", {
    className: "jsx-".concat(_buttonModule.default.__hash) + " " + "fa fa-".concat(rightIcon)
  })), /*#__PURE__*/_react.default.createElement(_style.default, {
    id: _buttonModule.default.__hash
  }, _buttonModule.default));
};
exports.Button = Button;
(0, _registerWidgetForDnD.registerKuiWidget)({
  name: "Button",
  component: Button,
  options: buttonProps,
  icon: "smart_button"
});